import * as React from 'react';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardCover from '@mui/joy/CardCover';
import Typography from '@mui/joy/Typography';
import Link from '@mui/joy/Link';
import Box from '@mui/joy/Box';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';

const SpotItemV2 = ({ spot, fromPath }) => {
    const { name, address, id, top_review_photo } = spot;
    const effectiveFromPath = fromPath || '/spots';
    const spotHref = `/spot/${id}?from=${encodeURIComponent(effectiveFromPath)}`;

    let image = "https://images.unsplash.com/photo-1542773998-9325f0a098d7?auto=format&fit=crop&w=320";
    if (top_review_photo && top_review_photo.image_link) {
        image = top_review_photo.image_link;
    }

    return (
        <Card
            sx={{
                minHeight: 280,
                minWidth: 0,
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'transform 200ms ease, box-shadow 200ms ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 'lg',
                },
            }}
        >
            <CardCover>
                <img
                    src={image}
                    loading="lazy"
                    alt={name}
                    style={{ objectFit: 'cover' }}
                />
            </CardCover>
            <CardCover
                sx={{
                    background:
                        'linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 120px)',
                }}
            />
            <CardContent sx={{ justifyContent: 'flex-end', overflow: 'hidden' }}>
                <Typography level="title-lg" textColor="#fff">
                    <Link
                        overlay
                        underline="none"
                        href={spotHref}
                        sx={{ color: '#fff' }}
                    >
                        {name}
                    </Link>
                </Typography>
                {address && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden' }}>
                        <LocationOnRoundedIcon sx={{ fontSize: 16, color: 'neutral.300', flexShrink: 0 }} />
                        <Typography
                            level="body-sm"
                            textColor="neutral.300"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'block',
                            }}
                        >
                            {address}
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}

export default SpotItemV2;
